class ProfileController {
  constructor (UserService) {
    'ngInject'
    this.userService = UserService
    this.isProcessing = true
    this.loaded = this.init()
  }

  init () {
    return this.userService.getCurrentUser()
    .then((user) => {
      this.user = user
      this.isProcessing = false
    })
  }
}

export default ProfileController



// WEBPACK FOOTER //
// ./src/app/pages/profile/profile.controller.js